export const pageSize = 'A4';
export const pageOrientation = 'portrait';
export const ios = 'ios';
export const safari = 'safari';